import { useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import ProspectDrawer from "@/components/ProspectDrawer";
import { STAGE_BADGE } from "@/components/PipelineStage";
import { AdminMloIntegration } from "@/components/AdminMloIntegration";
import { DeliveryLog } from "@/components/DeliveryLog";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AdminAstoria() {
  const [data, setData] = useState({ events: [], connections: [], webhook_url: "" });
  const [leads, setLeads] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = useCallback(async () => {
    try {
      const [o, l] = await Promise.all([api.get("/admin/integrations/astoria"), api.get("/prospects", { params: { source: "astoria" } })]);
      setData(o.data); setLeads(l.data);
    } catch (e) { toast.error(apiError(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div>
      <PageHeader title="Astoria / MortgageLeads.com" subtitle="Set up and supervise purchased-lead imports for every loan officer." />
      <Card className="mb-5 p-6" data-testid="admin-astoria-connections">
        <h3 className="font-semibold text-slate-900">Loan officer connections</h3>
        <p className="mb-2 mt-1 text-sm text-slate-500">Open Set up for a loan officer to copy the webhook URL, create their integration key, and send a test lead to their Zapier Catch Hook.</p>
        {data.connections.length === 0 ? <p className="text-sm text-slate-400">No active loan officers yet.</p> : data.connections.map((c) => (
          <AdminMloIntegration key={c.mlo_id} c={c} webhookUrl={data.webhook_url} onChanged={load} />
        ))}
      </Card>
      <Card className="mb-5 overflow-hidden" data-testid="admin-astoria-leads">
        <h3 className="px-6 pt-5 font-semibold text-slate-900">Imported leads</h3>
        {leads.length === 0 ? <p className="px-6 py-5 text-sm text-slate-400">No Astoria leads yet.</p> : (
          <div className="overflow-x-auto"><table className="mt-3 w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500"><tr><th className="px-6 py-2">Borrower</th><th className="px-4 py-2">Astoria lead ID</th><th className="hidden px-4 py-2 md:table-cell">Purpose</th><th className="px-4 py-2">Stage</th></tr></thead>
            <tbody className="divide-y divide-slate-100">{leads.map((p) => (
              <tr key={p.id} onClick={() => setSelected(p)} className="cursor-pointer hover:bg-amber-50/40" data-testid={`admin-astoria-lead-${p.id}`}>
                <td className="px-6 py-2 font-medium">{p.name || "—"}<div className="text-xs text-slate-500">{p.phone || p.email}</div></td>
                <td className="px-4 py-2">{p.astoria_lead_id}</td>
                <td className="hidden px-4 py-2 md:table-cell">{p.loan_purpose || p.opportunity_type || "—"}</td>
                <td className="px-4 py-2"><Badge className={`border-0 ${STAGE_BADGE[p.pipeline_stage || "New"]}`}>{p.pipeline_stage || "New"}</Badge></td>
              </tr>))}</tbody>
          </table></div>
        )}
      </Card>
      <DeliveryLog events={data.events} held={data.held_for_review || 0} onChanged={load} />
      <ProspectDrawer prospect={selected} onClose={() => setSelected(null)} onChange={load} />
    </div>
  );
}
